module.exports = __webpack_public_path__ + "img/filter_type_payment.95e5d692.png";